<template>
  <div>
    <CRow>
      <CCol lg="12">
        <CCard>
          <CCardHeader>
            <h3 class="card-title">新規会員ID</h3>
          </CCardHeader>
          <CCardBody>
            <CForm class="member-info edit-form">
              <CRow>
                <CCol class="px-0 pb-3">
                  <h4 class="sub-title">新規会員ID情報</h4>
                </CCol>
              </CRow>
              <CRow>
                <CCol lg="6">
                  <!-- <p>{{ itemToEdit }}</p> -->

                  <div
                    class="text-danger input-info"
                    v-if="
                      $v.itemToEdit.cardId.$dirty &&
                      !$v.itemToEdit.cardId.required
                    "
                  >
                    新カードIDの入力は必須です
                  </div>
                  <div
                    class="text-danger input-info"
                    v-if="
                      $v.itemToEdit.cardId.$dirty &&
                      !$v.itemToEdit.cardId.numeric
                    "
                  >
                    新カードIDは数値を入力してください
                  </div>
                  <div
                    class="text-danger input-info"
                    v-if="
                      $v.itemToEdit.cardId.$dirty &&
                      !$v.itemToEdit.cardId.maxLength
                    "
                  >
                    新カードIDは{{
                      valid.itemToEdit.cardId.length
                    }}桁の数値を入力してください
                  </div>
                  <div
                    class="text-danger input-info"
                    v-if="
                      $v.itemToEdit.cardId.$dirty &&
                      !$v.itemToEdit.cardId.minLength
                    "
                  >
                    新カードIDは{{
                      valid.itemToEdit.cardId.length
                    }}桁の数値を入力してください
                  </div>
                  <!-- <CInput
                    label="新カードID"
                    class="required-mark"
                    horizontal
                    v-model="ConvertId"
                  /> -->
                  <div class="required-mark form-group form-row">
                    <label class="col-form-label col-sm-3">新カードID</label>
                    <div class="col-sm-9">
                      <input
                        type="text"
                        class="form-control"
                        v-model="ConvertId"
                      />
                    </div>
                  </div>

                  <!-- <input type="text" v-model="ConvertId" /> -->
                </CCol>
              </CRow>

              <CRow>
                <CCol lg="6">
                  <div
                    class="text-danger input-info"
                    v-if="
                      $v.itemToEdit.familyName.$dirty &&
                      !$v.itemToEdit.familyName.required
                    "
                  >
                    氏の入力は必須です
                  </div>
                  <div class="required-mark form-group form-row">
                    <label class="col-form-label col-sm-3">氏</label>
                    <div class="col-sm-9">
                      <input
                        type="text"
                        class="form-control"
                        v-model="itemToEdit.familyName"
                        v-on:input="familyName_furigana"
                      />
                    </div>
                  </div>
                </CCol>
              </CRow>
              <CRow>
                <CCol lg="6">
                  <div
                    class="text-danger input-info"
                    v-if="
                      $v.itemToEdit.firstName.$dirty &&
                      !$v.itemToEdit.firstName.required
                    "
                  >
                    氏（カナ）の入力は必須です
                  </div>
                  <div
                    class="text-danger input-info"
                    v-if="!$v.itemToEdit.firstName.isKana"
                  >
                    氏（カナ）はカタカナを入力してください
                  </div>
                  <CInput
                    label="氏（カナ）"
                    class="required-mark"
                    horizontal
                    v-model="itemToEdit.firstName"
                  />
                </CCol>
              </CRow>
              <CRow>
                <CCol lg="6">
                  <div
                    class="text-danger input-info"
                    v-if="
                      $v.itemToEdit.givenName.$dirty &&
                      !$v.itemToEdit.givenName.required
                    "
                  >
                    名の入力は必須です
                  </div>
                  <!-- <CInput
                    label="名"
                    class="required-mark"
                    horizontal
                    v-model="itemToEdit.givenName"
                  /> -->
                  <div class="required-mark form-group form-row">
                    <label class="col-form-label col-sm-3">名</label>
                    <div class="col-sm-9">
                      <input
                        type="text"
                        class="form-control"
                        v-model="itemToEdit.givenName"
                        v-on:input="givenName_furigana"
                      />
                    </div>
                  </div>
                </CCol>
              </CRow>
              <CRow>
                <CCol lg="6">
                  <div
                    class="text-danger input-info"
                    v-if="
                      $v.itemToEdit.lastName.$dirty &&
                      !$v.itemToEdit.lastName.required
                    "
                  >
                    名（カナ）の入力は必須です
                  </div>
                  <div
                    class="text-danger input-info"
                    v-if="!$v.itemToEdit.lastName.isKana"
                  >
                    名（カナ）はカタカナを入力してください
                  </div>
                  <CInput
                    label="名（カナ）"
                    class="required-mark"
                    horizontal
                    v-model="itemToEdit.lastName"
                  />
                </CCol>
              </CRow>

              <!-- <CRow>
                <CCol class="px-0 pb-3 mt-4">
                  <span>Old ID: {{ itemToEdit.cardId }}</span>
                </CCol>
              </CRow> -->
            </CForm>
          </CCardBody>

          <CCardFooter>
            <div class="footer-navigation">
              <!-- <CButton
                @click="confirmModal = true"
                color="success"
                class="ml-0 px-5"
                ><i class="icon cil-save"></i> 保存</CButton
              > -->
              <!-- saveProfile() -->
              <CButton
                @click="
                  $v.itemToEdit.$invalid ? requiredFd() : (confirmModal = true)
                "
                color="success"
                class="ml-0 px-5"
                v-bind:class="$v.itemToEdit.$invalid ? 'inactive' : 'active'"
              >
                <i class="icon cil-user-follow"></i> 登録
              </CButton>
            </div>

            <!-- <CButton @click="goBack()" color="dark" class="ml-5 px-4">
              <b>←</b>戻る
            </CButton>-->
          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>

    <!-- <CButton
      @click="hasHistory() ? $router.go(-1) : $router.push('/')"
      class="my-5 btn btn-dark px-5"
    >
      <i class="icon cil-arrow-left"></i> 戻る
    </CButton> -->

    <CModal
      color="warning"
      :closeOnBackdrop="false"
      :centered="true"
      :show.sync="confirmModal"
    >
      <!-- 更新してよろしいですか？ -->
      <CInput
        label="カードID"
        horizontal
        plaintext
        v-model="itemToEdit.cardId"
      />
      <CInput label="ユーザ名" horizontal plaintext v-model="fullName" />
      <template #header> 発行確認 </template>
      <template #footer>
        <CButton
          @click="confirmModal = false"
          color="secondary"
          class="float-left"
          ><i class="icon cil-x"></i> 閉じる</CButton
        >
        <CButton @click="saveProfile()" color="success"
          ><i class="icon cil-send"></i> 登録</CButton
        >
      </template>
    </CModal>

    <CModal
      color="success"
      closeOnBackdrop
      :centered="true"
      :show.sync="completedModal"
    >
      <template #header>
        <h4>登録完了</h4>
      </template>
      登録が完了しました。
      <template #footer>
        <CButton @click="completedModal = false" color="danger"
          ><i class="icon cil-x"></i> 閉じる</CButton
        >
        <CButton @click="goDashboard()" color="success"
          ><i class="icon cil-send"></i> 会員ダッシュボードへ</CButton
        >
      </template>
    </CModal>
     
  </div>
</template>

<script>
// import Vue from 'vue'
import axios from "axios";
import {
  required,
  numeric,
  minLength,
  maxLength,
  helpers,
} from "vuelidate/lib/validators";
import historykana from "historykana";
import * as wanakana from "wanakana";

const CARD_ID = { LENGTH: 16 };

export default {
  components: {
    // FamilyMember
  },
  name: "AddMemberId",
  data() {
    return {
      confirmModal: false,
      addFamilyModal: false,
      editFamilyModal: false,
      deleteConfirmModal: false,
      deleteCompleteModal: false,
      completedModal: false,
      cardIdEditModal: false,
      engFirstName: true,
      engLastName: true,
      gUserName: "",
      history: [],
      admin: false,

      // fullName: "",
      // gUserName: "",

      currentItems: {},
      itemToRead: {
        name: "",
      },
      itemToEdit: {
        firstName: "",
        lastName: "",
        familyName: "",
        givenName: "",
        cardId: "",
      },

      newCardId: "",
      valid: {
        cardId: { length: CARD_ID.LENGTH },
      },
       
    };
  },
  computed: {
    fullName() {
      return this.itemToEdit.familyName + " " + this.itemToEdit.givenName;
    },
    ConvertId: {
      get() {
        return this.itemToEdit.cardId;
      },
      set(value) {
        var conv = value.replace(/[\uff01-\uff5e]/g, function (ch) {
          return String.fromCharCode(ch.charCodeAt(0) - 0xfee0);
        });
        this.itemToEdit.cardId = conv;
      },
    },
  },
  validations() {
    const isKana = helpers.regex("isKana", /^([ァ-ヴ][ァ-ヴー・]*)$/);

    return {
      itemToEdit: {
        familyName: { required, maxLength: maxLength(100) },
        firstName: {
          required,
          isKana: this.engFirstName ? false : isKana,
          maxLength: maxLength(100),
        },
        givenName: { required, maxLength: maxLength(100) },
        lastName: {
          required,
          isKana: this.engLastName ? false : isKana,
          maxLength: maxLength(100),
        },
        cardId: {
          required,
          numeric,
          minLength: minLength(CARD_ID.LENGTH),
          maxLength: maxLength(CARD_ID.LENGTH),
        },
      },
    };
  },
  methods: {
    saveProfile: function () {
      var urlRequest;
      urlRequest = "/rest/card";

      axios
        .post(urlRequest, this.itemToEdit, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          console.log("User profile updated:" + resp.data);
          this.itemToRead = resp.data;
          // this.putNewGroup(this.GUserId, this.userGroupName);
          this.itemToEdit = {
            firstName: "",
            lastName: "",
            familyName: "",
            givenName: "",
            cardId: "",
          };
          this.confirmModal = false;
          this.completedModal = true;
        })
        .catch((err) => {
          this.confirmModal = false;
           
          console.log("Updating profile error: " + err);
          this.errorDialog = true;
          if (err.response.status == 400) {
            this.errors = "このユーザーはすでに存在します";
          } else {
            this.errors = err;
          }
        });
    },

    familyName_furigana(input) {
      if (wanakana.isRomaji(input.target.value)) {
        this.itemToEdit.firstName = input.target.value;
        this.engFirstName = true;
      } else {
        this.engFirstName = false;
        this.history.push(input.target.value);
        this.itemToEdit.firstName = wanakana.toKatakana(
          historykana(this.history)
        );
      }
    },
    givenName_furigana(input) {
      if (wanakana.isRomaji(input.target.value)) {
        this.itemToEdit.lastName = input.target.value;
        this.engLastName = true;
      } else {
        this.engLastName = false;
        this.history.push(input.target.value);
        this.itemToEdit.lastName = wanakana.toKatakana(
          historykana(this.history)
        );
      }
    },
    requiredFd() {
      this.$v.itemToEdit.$touch();
    },
    goDashboard() {
      this.$router.push({
        name: "会員ダッシュボード",
        params: { userId: this.itemToRead.name, success: true },
      });
    },
    resetClose() {
      this.completedModal = false;
    },
  },
  beforeMount() {
    // this.getAllGroup();
  },
};
</script>